import Mustache from 'mustache';

import { useGlobalContext } from '@/hooks/use-global-context';

import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';

function useInterpolation() {
  const { pageMeta } = useGlobalContext();
  const { specialty } = useSpecialtyPageContext();

  const view = {
    pageMeta,
    specialty: {
      name: specialty?.title ?? '',
    },
    discipline: {
      name: specialty?.discipline?.title ?? '',
    },
  };

  return (title?: string, fallback?: string) => {
    try {
      return Mustache.render(title ?? '', view);
    } catch (e) {
      return fallback || title;
    }
  };
}

export default useInterpolation;
